import { useParams } from 'react-router-dom'
import { usePreferences } from 'context/preferences/PreferencesContext'
import { ContactCompanyType } from 'models/contact_companies'
import { getIdWithPrefix } from 'utils/pathUtils'
import useApiService from 'services/api'
import LoadingScreen from 'components/Layout/LoadingScreen'
import useDocumentTitle from 'components/useDocumentTitle'
import {
  MobileCompanyPageShell,
  MobileCompanyNotFound,
} from 'components/MobileCompanyPage/MobileCompanyPageShell'
import { buildConveniencePageContent } from './companyTypeData'

export function MobileConveniencePage() {
  const urlParams = useParams()
  const { preferences } = usePreferences()
  const convenienceID = urlParams?.convenience_id
    ? getIdWithPrefix(
        urlParams.convenience_id,
        preferences?.company_type_prefix_map[ContactCompanyType.Convenience]
      )
    : undefined

  const api = useApiService()
  const { data, isLoading } = api.useGetConvenience(convenienceID)

  // Shared derivation — same stats/fields as the desktop NewConveniencePage.
  const content = buildConveniencePageContent(data)
  useDocumentTitle(isLoading ? 'Loading...' : content.documentTitle)

  if (isLoading) {
    return <LoadingScreen />
  }

  if (!data || !content.contactCompanyId) {
    return <MobileCompanyNotFound label="Convenience Store not found" />
  }

  return (
    <MobileCompanyPageShell
      contactCompanyId={content.contactCompanyId}
      companyName={content.header.name}
      domain={content.header.domain}
      locationCount={content.doorsCount}
      summaryContent={content.summaryContent}
      locationDetailsContent={content.locationDetailsContent}
    />
  )
}
